import { render, staticRenderFns } from "./report.periodSummary.vue?vue&type=template&id=356aa0d4&lang=pug"
import script from "./report.periodSummary.vue?vue&type=script&lang=js"
export * from "./report.periodSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports